import React from 'react'
import { useSelector, usePublicLinks } from 'hooks'
import { Link, Icon, T, Copyright, StyledCopyright, SiteLogo } from 'components'
import styled from 'styled-components'
import { colors } from 'styles'

const iconsPerSex = {
  1: 'delete_success_male.svg',
  2: 'delete_success_female.svg',
}

const DeleteSuccess = () => {
  const sexId = useSelector(s => s.myProfile.members[0].sexOfMemberId)
  const siteName = useSelector(s => s.siteConfig.siteName)
  const links = usePublicLinks()

  return (
    <StyledDeleteSuccess>
      <header className="app-header">
        <SiteLogo external />
      </header>
      <main>
        <div className="icon">
          <Icon svg src={iconsPerSex[sexId]} />
        </div>
        <div className="user-icon" />
        <T as="p" className="success-message" label="removeAccount/accountRemoved" />
        <T as="p" className="thank-you-message" label="removeAccount/thankYouForChoosing" macros={{ siteName }} />
      </main>

      <footer>
        <nav>
          {links.map(link => (
            <T as={Link} className="nav-link" key={link.to} {...link} />
          ))}
        </nav>
        <p>
          <Copyright />
          <span className="powered-by">
            <T label="poweredBy" /> Dating Factory
          </span>
        </p>
      </footer>
    </StyledDeleteSuccess>
  )
}

const StyledDeleteSuccess = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-content: center;
  position: relative;
  box-sizing: border-box;
  min-height: 100vh;
  text-align: center;
  color: ${colors.textMain};

  main {
    margin: auto;
  }

  img,
  svg {
    backface-visibility: hidden;
  }

  .icon {
    width: 30vh;
    margin: 3rem auto 5rem;
    max-height: 30vh;
  }

  .success-message {
    margin-bottom: 0;
    font-size: 2.2rem;
    font-weight: 700;
    text-transform: uppercase;
    /* color: #7ed320; */
  }

  .thank-you-message {
    font-size: 1.8rem;
    margin-top: 1rem;
  }

  ${StyledCopyright} {
    justify-content: center;
  }

  footer {
    display: flex;
    flex-direction: column;
    width: 100%;

    nav {
      display: flex;
      justify-content: center;
      margin: 1em;
    }
    a {
      font-size: 1.4rem;
      text-decoration: none;
      color: ${colors.textSecondary};
    }
    a + a {
      margin-left: 2rem;
    }
    p {
      color: ${colors.textSecondary};
      font-size: 1.4rem;
      margin-top: 0.5rem;

      span ~ span {
        margin-left: 0.5rem;
      }
    }
  }

  .powered-by {
    margin-left: 1rem;
  }
`

export default DeleteSuccess
